const formatHex = (hex: string) => {
  const h = hex.includes('x') ? hex.slice(2) : hex;

  return h.replace(/^0+/, '').toLowerCase();
};

export const compareHex = (
  hex1: string | undefined,
  hex2: string | undefined
) => {
  const h1 = hex1 && formatHex(hex1);
  const h2 = hex2 && formatHex(hex2);

  return h1 === h2;
};

export const gWeiToWei = (gwei: string) => {
  let [
    // eslint-disable-next-line prefer-const
    wholePart,
    decimalPart,
  ] = gwei.split('.');

  if (decimalPart) {
    if (decimalPart.length < 9) {
      decimalPart = `${decimalPart}${'0'.repeat(9 - decimalPart.length)}`;
    } else if (decimalPart.length > 9) {
      decimalPart = decimalPart.slice(0, 9);
    }
  } else {
    decimalPart = '0'.repeat(9);
  }
  return BigInt(`${wholePart}${decimalPart}`);
};
